export default __webpack_public_path__ + "static/Retail-casestudy-app-9c0abbd1afbae8901ce6f8bfe7d89da2.webp";